import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { useShallowEqualSelector } from 'custom-hooks/useShallowEqualSelector'
import ProfileForm from './components/ProfileForm'
import ProfileAvatarSection from './components/ProfileAvatarSection'
import Spinner from 'components/CommonUI/Spinner/Spinner'
import SuccesModal from 'components/SuccessModal/SuccesModal'

import { clearProfile, getIsFetchingSelector } from 'redux/reducers/profile'

const Profile = () => {
  const dispatch = useDispatch()
  const isFetching = useShallowEqualSelector(getIsFetchingSelector)

  useEffect(() => {
    return () => {
      dispatch(clearProfile())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="profile_container">
      <div className="form_container">
        <ProfileAvatarSection />
        <ProfileForm />
        <SuccesModal />
        {isFetching && <Spinner />}
      </div>
    </div>
  )
}

export default Profile
